import type { CSSProperties, ReactNode } from 'react';

import './GridFrame.css';

type Pad = 'none' | 'tight' | 'default' | 'loose';
type Fill = 'none' | 'surface' | 'blue' | 'blue-wash' | 'amber-wash';

interface GridFrameProps {
  children?: ReactNode;
  /** Columns this cell spans in the parent .hgrid. */
  span?: number;
  pad?: Pad;
  fill?: Fill;
  /** Ink borders instead of hairline. */
  strong?: boolean;
  className?: string;
  style?: CSSProperties;
}

export default function GridFrame({
  children,
  span = 1,
  pad = 'default',
  fill = 'none',
  strong = false,
  className,
  style,
}: GridFrameProps) {
  const classes = [
    'cell',
    `cell--pad-${pad}`,
    fill === 'none' ? null : `cell--fill-${fill}`,
    strong ? 'cell--strong' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      style={{
        ...(span > 1 ? { gridColumn: `span ${span}` } : null),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
